import { ApiAddressSuggestion, ApiAddressSuggestions } from '@/types/address-suggestions'
import type { CustomerAddress } from '@/types/customers'

export const getAddressSuggestions = async (query: string): Promise<ApiAddressSuggestions> => {
  const apiQuery = new URLSearchParams({ query })
  const res = await fetch(`/api/address-suggestions?${apiQuery}`)
  if (!res.ok) throw Error()
  return res.json()
}

export const addressSuggestionToCustomerAddress = (address: ApiAddressSuggestion): CustomerAddress => {
  const street = address.adressenavn ?? '?'
  const houseNumber = `${address.nummer}${address.bokstav}`
  const postalCode = address.postnummer
  const city = address.poststed
  const country = address.land ?? 'NO'
  return {
    fullAddress: `${street} ${houseNumber}, ${postalCode} ${city}`,
    street,
    houseNumber,
    postalCode,
    city,
    country,
    locations: [],
  }
}

export const formatAddressSuggestion = (adresse: ApiAddressSuggestion) =>
  `${adresse.adressetekst}, ${adresse.postnummer} ${adresse.poststed}`
